import { render, staticRenderFns } from "./StatList.vue?vue&type=template&id=c5e89c30&scoped=true"
import script from "./StatList.vue?vue&type=script&lang=js"
export * from "./StatList.vue?vue&type=script&lang=js"
import style0 from "./StatList.vue?vue&type=style&index=0&id=c5e89c30&prod&lang=scss"
import style1 from "./StatList.vue?vue&type=style&index=1&id=c5e89c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e89c30",
  null
  
)

export default component.exports